var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21,13v9.5a.5.5,0,0,1-.5.5h-6a.5.5,0,0,1-.5-.5V16H10v6.5a.5.5,0,0,1-.5.5h-6a.5.5,0,0,1-.5-.5v-10a.5.5,0,0,1,1,0V22H9V15.5a.5.5,0,0,1,.5-.5h5a.5.5,0,0,1,.5.5V22h5V13a.5.5,0,0,1,1,0Zm2.85-1.35L12.35.15a.48.48,0,0,0-.7,0L.15,11.65a.48.48,0,0,0,0,.7.48.48,0,0,0,.7,0L12,1.21,23.15,12.35a.48.48,0,0,0,.7,0A.48.48,0,0,0,23.85,11.65ZM16,2h3V5a.5.5,0,0,0,1,0V1.5a.5.5,0,0,0-.5-.5H16a.5.5,0,0,0,0,1Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.24edb32d748e3eaa964020a3185506a1.svg";
export { ForwardRef as ReactComponent };